// Display labels for message types, statuses and the server's skip reasons
// ("email:no_consent,sms:not_configured").

export const STATUS_COLORS = {
  pending: "processing",
  sent: "success",
  failed: "error",
  skipped: "default"
};

export const purposeLabels = t => ({
  appointment_confirmation: t("Appointment confirmation"),
  appointment_rescheduled: t("Appointment moved"),
  appointment_reminder: t("Appointment reminder"),
  on_the_way: t("On the way"),
  review_request: t("Review request"),
  test: t("Test message")
});

export const statusLabels = t => ({
  pending: t("Sending"),
  sent: t("Sent"),
  failed: t("Failed"),
  skipped: t("Not sent")
});

export const channelLabels = t => ({
  email: t("Email"),
  sms: t("SMS"),
  whatsapp: t("WhatsApp")
});

const reasonLabels = t => ({
  no_consent: t("no consent"),
  not_configured: t("not configured"),
  disabled: t("switched off"),
  no_address: t("no address"),
  no_template: t("no template"),
  failed: t("provider error"),
  no_customer: t("no customer"),
  cooldown: t("asked recently"),
  no_platform: t("no review link"),
  no_public_url: t("server address unknown")
});

/** "email:no_consent,sms:not_configured" → "Email: no consent · SMS: not configured". */
export const describeReason = (reason, t) => {
  if (!reason) return "";
  const reasons = reasonLabels(t);
  const channels = channelLabels(t);
  return String(reason)
    .split(",")
    .map(part => {
      const at = part.indexOf(":");
      const channel = at > 0 ? part.slice(0, at) : "";
      const code = part.slice(at + 1);
      if (!channels[channel]) return reasons[part] || part;
      return `${channels[channel]}: ${reasons[code] || code}`;
    })
    .join(" · ");
};

export const formatDateTime = (value, lng) =>
  value
    ? new Date(value).toLocaleString(lng || "de", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      })
    : "—";
